<div [formGroup]="contactRequestForm" class="main-container">
    <div class="left-container">
        <table class="form-table">
            <tr>
                <td>
                   Lead Type
                </td>
                <td>
                    <p-dropdown [options]="leadTypes" optionLabel="name" formControlName="leadType"></p-dropdown>
                </td>
            </tr>
            <tr>
                <td>First name</td>
                <td> <input pInputText formControlName="firstName"></td>
            </tr>
            <tr>
                <td>Family name</td>
                <td> <input pInputText formControlName="lastName"></td>
            </tr>
            <tr>
                <td>Language</td>
                <td>
                    <p-dropdown [options]="languages" optionLabel="name" formControlName="language"></p-dropdown>
                </td>
            </tr>
            <tr>
                <td>Email</td>
                <td> <input pInputText formControlName="email"></td>
            </tr>
            <tr>
                <td> Phone number</td>
                <td> <input pInputText formControlName="phoneNumber"></td>
            </tr>
            <tr>
                <td> Country</td>
                <td>
                    <p-dropdown [options]="countries" optionLabel="name" formControlName="country"></p-dropdown>
                </td>
            </tr>
            <tr>
                <td> City</td>
                <td> <input pInputText formControlName="city"></td>
            </tr>
            <tr>
                <td> Post code</td>
                <td> <input pInputText formControlName="postCode"></td>
            </tr>
            <tr>
                <td>Programme</td>
                <td> <input pInputText formControlName="interestedIn"></td>
            </tr>
            <tr>
                <td>Message</td>
                <td> <textarea class="message-box" rows="10" pInputTextarea formControlName="message"></textarea></td>
            </tr>
        </table>
    </div>
    <div class="right-container">
        <table class="form-table">
            <tr>
                <td>Interested?</td>
                <td>
                    <p-selectButton [options]="interestLevels" optionLabel="name" formControlName="interestLevel">
                    </p-selectButton>
                </td>
            </tr>
            <tr>
                <td>Follow up date</td>
                <td>
                    <p-calendar formControlName="dateToContact" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                </td>
            </tr>
            <tr>
                <td>Agent</td>
                <td>
                    <p-dropdown [options]="salesAgents" formControlName="salesAgent" optionLabel="name"></p-dropdown>
                </td>
            </tr>
            <tr>
                <td>Assigned users</td>
                <td>
                    <table class="person-table" *ngIf="counsellors.length > 0">
                        <tr>
                            <th class="first-col"></th>
                            <th></th>
                        </tr>
                        <tr formArrayName="usersInCharge"
                            *ngFor="let user of usersFormArray; let i = index">
                            <td>
                                <p-checkbox [formControlName]="i" [binary]="true"></p-checkbox>
                            </td>
                            <td>
                                <p class="counsellor-name">
                                    {{counsellors[i].name | titlecase}}
                                </p>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    Start/Departure
                </td>
                <td>
                    <p-calendar formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                </td>
            </tr>
            <tr>
                <td>
                    End/Return
                </td>
                <td>
                    <p-calendar formControlName="endDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                </td>
            </tr>
            <tr>
                <td>
                  Course intensity
                </td>
                <td>
                  <input pInputText formControlName="courseType">
                </td>
              </tr>
              <tr>
                <td>
                  Course option
                </td>
                <td>
                  <input pInputText formControlName="courseOption">
                </td>
              </tr>
              <tr>
                <td>
                    School
                </td>
                <td>
                    <p-dropdown placeholder="SELECT" dataKey="id" [options]="filteredSchools" optionLabel="name" [showClear]="true"
                        formControlName="school" [filter]="true" filterBy="name" (onChange)="onSchoolUpdate($event.value)" (onClear)="onSchoolClear()"></p-dropdown>
                </td>
            </tr>
            <tr>
                <td>
                    Destination
                </td>
                <td>
                    <p-dropdown placeholder="SELECT" dataKey="id" [options]="filteredCountries" optionLabel="name" [showClear]="true"
                        formControlName="destination" [filter]="true" filterBy="name" (onChange)="onDestinationUpdate($event.value)" (onClear)="onDestinationClear()"></p-dropdown>
                </td>
            </tr>
            <tr>
                <td>
                    Birth date
                </td>
                <td>
                    <p-calendar formControlName="birthDate" dateFormat="dd/mm/yy" [showIcon]="true" [yearNavigator]="true"
                        yearRange="1970:2030"></p-calendar>
                </td>
            </tr>
        </table>
    </div>
</div>
<p-button [disabled]="contactRequestForm.invalid" (onClick)="createContactRequest()" label="Submit"></p-button>